import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {AuthState} from './shared/states/AuthState';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {AuthUserState} from './shared/states/AuthUserState';
import {logout} from './Helpers';
import UpdateUser from './shared/auth/UpdateUser';
import Refresh from './shared/auth/Refresh';
import Login from './shared/auth/Login';
import Logout from './shared/auth/Logout';
import {User, hasPermission} from 'jugacu-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  private authenticated$: Subscription;
  authenticated: boolean;

  private user$: Subscription;
  user: User;

  authorized: boolean;

  private route$: Subscription;
  authenticating: boolean;

  private actions$: Subscription;

  constructor(
    private store: Store,
    private router: Router,
    private actions: Actions
  ) {
    this.actions$ = this.actions.pipe(ofActionDispatched(Logout)).subscribe(async () => {
      await this.router.navigate(['/']);
    });

    this.authenticated$ = store.select(AuthState.isAuthenticated).subscribe(async (val) => {
      this.authenticated = val;

      if (this.authenticated) {
        try {
          await this.store.dispatch(new UpdateUser(this.store.selectSnapshot(AuthState.token))).toPromise();
        } catch (e) {
          this.logout();
        }
      }
    });

    this.route$ = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(
      async (val) => {
        await this.checkToken();
      }
    );

    this.user$ = store.select(AuthUserState.user).subscribe((user: User) => {
      this.user = user;

      this.authorized = hasPermission('use whistler', user);
    });
  }

  private async checkToken(): Promise<void> {

    if (this.authenticating) {
      return;
    }

    if (this.store.selectSnapshot(AuthState.isExpired) && this.store.selectSnapshot(AuthState.refreshToken)) {
      try {
        this.authenticating = true;
        await this.store.dispatch(new Refresh({refreshToken: this.store.selectSnapshot(AuthState.refreshToken)})).toPromise();
        this.authenticating = false;
      } catch (e) {
        try {
          await this.logout();
        } catch (e) {
          //
        }
        // this.authenticatingError = true;
      }
    }

    const authorization = window.location.search.slice(1).split('&')[0].split('=')[1];

    if (authorization && !this.authenticated) {
      try {
        this.authenticating = true;
        await this.store.dispatch(new Login({authorization})).toPromise();
        this.authenticating = false;
      } catch (e) {
        try {
          await this.logout();
        } catch (e) {
          //
        }
        // this.authenticatingError = true;
      } finally {
        window.history.replaceState({}, document.title, '/');
      }
    }
  }

  ngOnDestroy(): void {
    this.authenticated$.unsubscribe();
    this.route$.unsubscribe();
    this.actions$.unsubscribe();
    this.user$.unsubscribe();
  }

  private async logout() {
    await logout(this.store);
  }
}
